module.exports = __webpack_public_path__ + "img/persil_frise_md.6c3b2dd4.jpg";